export let CartType;(function(a){a[a.RedirectToCart=0]="RedirectToCart",a[a.StayOnPage=1]="StayOnPage",a[a.ShowPopup=2]="ShowPopup"})(CartType||(CartType={}));